!function() {
    "use strict";
    var e, t = {
        537: function(e, t, n) {
            n(586);
            var o = n(18), r = function() {
                var e = document.querySelector(".blog-list"), t = document.querySelector("[srt-title]"), n = (document.querySelector("[fltr-title]"), 
                (0, o.Z)(e.querySelectorAll(".item"))), r = window.location.href;
                "published_at-ascending" == new URL(r).searchParams.get("sort_by") && (t.innerHTML = "Oldest to newest", 
                e.innerHTML = "", n.reverse().forEach(function(t) {
                    e.appendChild(t);
                }));
            }, c = n(560), i = n(808), l = n.n(i), a = n(861), s = n(265), u = n.n(s), d = n(772), f = n(358), m = n(82), p = n(669), v = n.n(p), y = n(127);
            f.p8.registerPlugin(m.i);
            var g = function() {
                f.p8.to("body", {
                    opacity: 1,
                    duration: .5,
                    ease: "power1.in"
                }), function() {
                    var e = document.querySelector(".cookie__container"), t = document.querySelector(".cookie__close"), n = document.querySelector(".cookie__accept");
                    function o() {
                        e.classList.remove("active");
                    }
                    1 != function(e) {
                        for (var t = "acceptCookies=", n = decodeURIComponent(document.cookie).split(";"), o = 0; o < n.length; o++) {
                            for (var r = n[o]; " " == r.charAt(0); ) r = r.substring(1);
                            if (0 == r.indexOf(t)) return r.substring(t.length, r.length);
                        }
                        return "";
                    }() && e.classList.add("active"), n.addEventListener("click", function() {
                        !function(e, t, n) {
                            var o = new Date();
                            o.setTime(o.getTime() + 2592e6);
                            var r = "expires=" + o.toUTCString();
                            document.cookie = "acceptCookies=1;" + r + ";path=/";
                        }(), o();
                    }), t.addEventListener("click", function() {
                        o();
                    });
                }(), function() {
                    var e = document.querySelector(".js-subject-dropdown"), t = document.querySelector(".js-subject-input");
                    if (e && t) {
                        var n = document.querySelectorAll(".js-subject-dropdown .select-item");
                        n.length && n.forEach(function(e) {
                            e.addEventListener("click", function() {
                                t.value = e.innerText;
                            });
                        });
                    }
                }();
                var e, t = document.querySelector(".age-block");
                t && function() {
                    if (l().get("age")) t.style.display = "none", t.classList.add("hidden"); else {
                        u().disablePageScroll();
                        var e = "Power3.easeIn";
                        document.querySelectorAll("[herb-step-1]").forEach(function(t) {
                            "top" == t.dataset.direction ? f.p8.to(t, {
                                y: "-100%",
                                duration: 1,
                                delay: 1,
                                ease: e
                            }) : "bottom" == t.dataset.direction ? f.p8.to(t, {
                                y: "100%",
                                duration: 1,
                                delay: 1.3,
                                ease: e
                            }) : "right" == t.dataset.direction ? f.p8.to(t, {
                                x: "100%",
                                duration: 1,
                                delay: 1.6,
                                ease: e
                            }) : "left" == t.dataset.direction && f.p8.to(t, {
                                x: "-100%",
                                duration: 1,
                                delay: 1.9,
                                ease: e
                            });
                        }), document.querySelectorAll("[herb-step-2]").forEach(function(t) {
                            "top" == t.dataset.direction ? f.p8.to(t, {
                                y: "-100%",
                                duration: 1,
                                delay: 1.7,
                                ease: e
                            }) : "bottom" == t.dataset.direction ? f.p8.to(t, {
                                y: "100%",
                                duration: 1,
                                delay: 2,
                                ease: e
                            }) : "right" == t.dataset.direction ? f.p8.to(t, {
                                x: "100%",
                                duration: 1,
                                delay: 2.3,
                                ease: e
                            }) : "left" == t.dataset.direction && f.p8.to(t, {
                                x: "-100%",
                                duration: 1,
                                delay: 2.6,
                                ease: e
                            });
                        }), document.querySelectorAll("[herb-step-3]").forEach(function(t) {
                            "top" == t.dataset.direction ? f.p8.to(t, {
                                y: "-100%",
                                duration: 1,
                                delay: 2.4,
                                ease: e
                            }) : "bottom" == t.dataset.direction ? f.p8.to(t, {
                                y: "100%",
                                duration: 1,
                                delay: 2.7,
                                ease: e
                            }) : "right" == t.dataset.direction ? f.p8.to(t, {
                                x: "100%",
                                duration: 1,
                                delay: 3,
                                ease: e
                            }) : "left" == t.dataset.direction && f.p8.to(t, {
                                x: "-100%",
                                duration: 1,
                                delay: 3.3,
                                ease: e
                            });
                        }), document.querySelectorAll("[herb-step-4]").forEach(function(t) {
                            "top" == t.dataset.direction ? f.p8.to(t, {
                                y: "-100%",
                                duration: 1,
                                delay: 2.9,
                                ease: e
                            }) : "bottom" == t.dataset.direction ? f.p8.to(t, {
                                y: "100%",
                                duration: 1,
                                delay: 3.2,
                                ease: e
                            }) : "right" == t.dataset.direction ? f.p8.to(t, {
                                x: "100%",
                                duration: 1,
                                delay: 3.6,
                                ease: e
                            }) : "left" == t.dataset.direction && f.p8.to(t, {
                                x: "-100%",
                                duration: 1,
                                delay: 3.9,
                                ease: e
                            });
                        });
                    }
                    t.querySelector(".yes").addEventListener("click", function(e) {
                        e.preventDefault(), l().set("age", "true", {
                            expires: 7
                        }), t.classList.add("hidden"), u().enablePageScroll();
                    });
                }(), e = document.querySelector(".welcome-block"), !l().get("welcome") && l().get("age") && setTimeout(function() {
                    e.classList.add("active");
                }, 10e3), document.querySelectorAll(".welcome-block .close").forEach(function(t) {
                    t.addEventListener("click", function() {
                        l().set("welcome", "true", {
                            expires: 30
                        }), e.classList.remove("active");
                    });
                }), e.querySelector("form").addEventListener("submit", function() {
                    l().set("welcome", "true", {
                        expires: 30
                    });
                });
                var n, o, r, i, s, p, g, h, S, q, b, L, w, k, E, _, x = document.querySelector(".top-line");
                function A() {
                    var e = document.querySelectorAll(".top-block .item");
                    if (e) for (var t = 0; t < e.length; t++) {
                        var n = e[t].querySelector(".wrapper .text-block .title-slider"), o = n.getBoundingClientRect().top, r = n.offsetHeight, c = e[t].querySelector(".scroll-bottom .text").getBoundingClientRect().top - 60 - r - o, i = e[t].querySelector(".line");
                        i.style.height = c + "px", i.style.top = "-" + c - 30 + "px";
                    }
                }
                function P() {
                    var e = document.querySelector(".main-header");
                    window.pageYOffset > 1 ? e.classList.add("fixed") : e.classList.remove("fixed");
                }
                function T(e) {
                    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop;
                    return {
                        top: t.top + o,
                        left: t.left + n,
                        width: t.width,
                        height: t.height
                    };
                }
                x && (l().get("topPromo") || (x.classList.add("active"), (E = document.querySelector(".top-line__list")) && new c.Z(E, {
                    slidesPerView: 1,
                    loop: !1,
                    navigation: {
                        nextEl: ".top-line__inner .nav.next",
                        prevEl: ".top-line__inner .nav.prev"
                    },
                    breakpoints: {}
                }), (_ = x.querySelector(".close")) && _.addEventListener("click", function() {
                    x.classList.remove("active"), console.log(1), l().set("topPromo", "true", {
                        expires: 1
                    }), console.log(2);
                }))), n = window.innerHeight, o = window.innerWidth, (r = document.querySelector(".top-block")) && n > 660 && o < 480 && (r.style.height = n + "px", 
                r.querySelectorAll(".item").forEach(function(e) {
                    e.style.height = n + "px";
                })), i = document.querySelectorAll(".top-menu__list-item"), s = document.querySelector(".main-header"), 
                i.forEach(function(e) {
                    e.addEventListener("mouseenter", function(t) {
                        if (e.classList.contains("dropdown")) {
                            t.preventDefault();
                            var n = document.querySelector(".sub-menu.open"), o = document.querySelector(".top-menu__list-item.dropdown.open");
                            n && (n.classList.remove("open"), o.classList.remove("open"));
                            var r = this.getAttribute("data-id"), c = document.getElementById(r);
                            s.classList.add("open-menu"), c.classList.add("open"), e.classList.add("open");
                            var i = document.querySelector(".sub-menu.open");
                            i && s.addEventListener("mouseleave", function() {
                                s.classList.remove("open-menu"), i.classList.remove("open"), e.classList.remove("open");
                            });
                        } else {
                            var l = document.querySelector(".sub-menu.open");
                            l && l.classList.remove("open");
                        }
                    });
                }), function() {
                    var e = document.querySelector(".mobile-btn"), t = document.querySelector(".mobile-menu"), n = document.querySelector(".main-header");
                    t && e.addEventListener("click", function(o) {
                        o.preventDefault(), t.classList.toggle("open"), n.classList.toggle("open-mobile-menu"), 
                        this.classList.toggle("open"), e.classList.contains("open") ? u().disablePageScroll() : u().enablePageScroll();
                    });
                    var o = document.querySelectorAll(".mobile-menu__item.dropdown"), r = document.querySelector(".mobile-menu__transform"), c = document.querySelectorAll(".mobile-menu__submenu");
                    o.forEach(function(e) {
                        e.addEventListener("click", function(e) {
                            e.preventDefault();
                            var t = this.getAttribute("data-id"), n = document.getElementById(t), o = this.getAttribute("data-name");
                            r.classList.add("slide"), n.classList.add("open"), document.getElementById("name-submenu").innerHTML = o;
                        });
                    });
                    var i = document.querySelector(".mobile-menu .back");
                    i && i.addEventListener("click", function(e) {
                        e.preventDefault(), r.classList.remove("slide"), c.forEach(function(e) {
                            e.classList.remove("open");
                        });
                    }), document.querySelectorAll(".mobile-menu__submenu").forEach(function(e) {
                        new d.Z(e);
                    });
                }(), document.querySelector(".cart-block .overlay").addEventListener("click", function() {
                    cartBlock.classList.remove("open"), u().enablePageScroll();
                }), function() {
                    var e = document.querySelector(".basket-top"), t = document.querySelector(".cart-block");
                    if (e) {
                        e.addEventListener("click", function(e) {
                           // e.preventDefault(), t.classList.add("open"), u().disablePageScroll();
                           window.location.href="/cart";
                        });
                        var n = document.querySelector(".cart-scroll-block");
                        n && new d.Z(n);
                    }
                }(), function() {
                    var e = document.querySelector(".cart-block .close"), t = document.querySelector(".cart-block");
                    e.addEventListener("click", function(e) {
                        e.preventDefault(), t.classList.remove("open"), u().enablePageScroll();
                    });
                }(), function() {
                    var e = document.querySelector(".top-block__slider");
                    e && new c.Z(e, {
                        slidesPerView: 1,
                        loop: !1,
                        speed: 1500,
                        pagination: {
                            el: ".top-block__pagination",
                            clickable: !0
                        }
                    });
                }(), function() {
                    var e = document.querySelector(".featured-block__slider");
                    e && new c.Z(e, {
                        slidesPerView: 2,
                        loop: !1,
                        spaceBetween: 30,
                        speed: 1500,
                        pagination: {
                            el: ".features-block__pagination",
                            clickable: !0
                        },
                        navigation: {
                            nextEl: ".features-block__nav .arrow.next",
                            prevEl: ".features-block__nav .arrow.prev"
                        },
                        breakpoints: {
                            992: {
                                slidesPerView: "auto",
                                spaceBetween: 20
                            }
                        }
                    });
                }(), function() {
                    var e = document.querySelector(".cart-block__slider");
                    e && new c.Z(e, {
                        slidesPerView: 4,
                        loop: !1,
                        spaceBetween: 30,
                        speed: 1500,
                        pagination: {
                            el: ".features-block__pagination",
                            clickable: !0
                        },
                        navigation: {
                            nextEl: ".features-block__nav .arrow.next",
                            prevEl: ".features-block__nav .arrow.prev"
                        },
                      autoplay: {
                        delay: 3000,
                      },
                     	breakpoints: {
                          	380: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20
                            },                        
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            }
                        }
                      	
                    });
                }(), function() {
                  if ($('#popup_upsell_slider .swiper-slide').length == 4) {
                  var e = document.querySelector("#popup_upsell_slider");
                    e && new c.Z(e, {
                      slidesPerView: 4,
                      enabled: false,
                      loop: !1,
                      spaceBetween: 25,
                      speed: 1500,
                      centeredSlides: false,
                      navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                      },
                      autoplay: {
                        delay: 3000,
                      },
                      breakpoints: {
                          576: {
                            enabled: true,
                            slidesPerView: 1,
                            spaceBetween: 25
                          },
                          767: {
                            enabled: true,
                            slidesPerView: 2,
                            spaceBetween: 25
                          },                        
                          1024: {
                            enabled: true,
                            slidesPerView: 3,
                            spaceBetween: 25,
                          }
                      }
                    });
                } else if($('#popup_upsell_slider .swiper-slide').length == 3){
                    var e = document.querySelector("#popup_upsell_slider");
                    e && new c.Z(e, {
                      slidesPerView: 3,
                      enabled: false,
                      loop: !1,
                      spaceBetween: 25,
                      speed: 1500,
                      centeredSlides: false,
                      navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                      },
                      autoplay: {
                        delay: 3000,
                      },
                      breakpoints: {
                          576: {
                            enabled: true,
                            slidesPerView: 1,
                            spaceBetween: 25
                          },
                          767: {
                            enabled: true,
                            slidesPerView: 2,
                            spaceBetween: 25
                          },                        
                          1024: {
                            enabled: true,
                            slidesPerView: 3,
                            spaceBetween: 25,
                          }
                      }
                    });
                    
                } else if($('#popup_upsell_slider .swiper-slide').length == 2){
                    var e = document.querySelector("#popup_upsell_slider");
                    e && new c.Z(e, {
                      slidesPerView: 2,
                      enabled: false,
                      loop: !1,
                      spaceBetween: 25,
                      speed: 1500,
                      centeredSlides: false,
                      navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                      },
                      autoplay: {
                        delay: 3000,
                      },
                      breakpoints: {
                          576: {
                            enabled: true,
                            slidesPerView: 1,
                            spaceBetween: 25
                          },
                          767: {
                            enabled: true,
                            slidesPerView: 2,
                            spaceBetween: 25
                          }
                      }
                    });
                    
                } else {
                    var e = document.querySelector("#popup_upsell_slider");
                    e && new c.Z(e, {
                      slidesPerView: 1,
                      loop: !1,
                      spaceBetween: 25,
                      speed: 1500,
                      centeredSlides: false,
                      navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                      },
                      autoplay: {
                        delay: 3000,
                      },
                      breakpoints: {
                        576: {
                          slidesPerView: 1,
                          spaceBetween: 25
                        }
                      }
                    });
                }
                }(), function() {
                    var e = document.querySelector(".collection-block__slider");
                    if (e) {
                        var t = new c.Z(e, {
                            slidesPerView: "auto",
                            loop: !0,
                            spaceBetween: 30,
                            speed: 1500,
                            centeredSlides: !0,
                            pagination: {
                                el: ".collection-pagination",
                                clickable: !0
                            },
                            navigation: {
                                nextEl: ".collection-nav .next",
                                prevEl: ".collection-nav .prev"
                            },
                            on: {
                                slideChangeTransitionEnd: function() {
                                    !function() {
                                        for (var t = document.getElementsByClassName("swiper-slide-active"), n = 0; n < t.length; n++) t[n].addEventListener("mouseover", function(t) {
                                            e.classList.add("hover-item");
                                        }), t[n].addEventListener("mouseout", function(t) {
                                            e.classList.remove("hover-item");
                                        });
                                    }();
                                }
                            },
                            breakpoints: {
                                767: {
                                    spaceBetween: 16
                                },
                                992: {
                                    spaceBetween: 18
                                }
                            }
                        }), n = t.slides.length - 2 * t.loopedSlides, o = t.realIndex + 1, r = document.getElementById("total-slide"), i = document.getElementById("count-slide");
                        r.innerHTML = n < 10 ? "0" + n : n, i.innerHTML = o < 10 ? "0" + o : o, t.on("slideChange", function() {
                            o = t.realIndex + 1, i.innerHTML = o < 10 ? "0" + o : o;
                        });
                    }
                }(), A(), p = document.querySelector(".menu-block__title"), g = document.querySelector(".menu-block__content"), 
                p && p.addEventListener("click", function(e) {
                    e.preventDefault(), p.classList.toggle("active"), g.classList.toggle("active");
                }), document.querySelectorAll(".btn-popup-get").forEach(function(e) {
                    var t = document.querySelector(".new-get"), n = t.querySelectorAll(".close");
                    e && (e.addEventListener("click", function(e) {
                        e.preventDefault(), t.classList.add("active");
                    }), n.forEach(function(e) {
                        e.addEventListener("click", function() {
                            t.classList.remove("active");
                        });
                    }));
                }), function() {
                    var e = document.querySelector(".img-text-block .slider-list");
                    e && new c.Z(e, {
                        slidesPerView: 1,
                        loop: !0,
                        speed: 1500,
                        centeredSlides: !0,
                        pagination: {
                            el: ".slider-pagination",
                            clickable: !0
                        },
                        breakpoints: {
                            767: {
                                spaceBetween: 16
                            },
                            992: {
                                spaceBetween: 18
                            }
                        }
                    });
                }(), /*function() {
                    document.querySelector(".top-product"), document.querySelector(".featured-block");
                    var e = document.querySelector(".product-about-info"), t = document.querySelector(".product-img"), n = document.querySelector(".product-img__block");
                    if (t || e) {
                        var o = e.querySelector(".img-text-block:last-child"), r = getComputedStyle(o), c = parseInt(r.paddingBottom, 10);
                        m.i.create({
                            trigger: ".product-wrapper",
                            start: "top top",
                            end: "bottom bottom",
                            scrub: !0,
                            onUpdate: function(o) {*/ 
                                /*if (1 > o.progress > 0) {
                                    var r = o.progress * (T(e).top + T(e).height - T(t).height - T(n).top - c + 50);
                                    f.p8.to(t, {
                                        y: r
                                    });
                                }*/
                            /*}
                        });
                    }
                }(),*/ h = document.querySelector("#engrav-float"), S = document.querySelector(".float-product-info .engrav-info"), 
                q = document.querySelectorAll(".count-add"), b = document.querySelectorAll("[engrav-price]"), 
                L = document.querySelector("#engrav"), w = document.querySelector(".float-product-info"), 
                L && (h && (h.onclick = function() {
                    L.click(), this.checked ? S.classList.add("active") : S.classList.remove("active"), 
                    q.forEach(function(e) {
                        e.classList.toggle("hidden");
                    }), b.forEach(function(e) {
                        e.classList.toggle("hidden");
                    });
                }), L.addEventListener("click", function() {
                    h.click(), L.checked ? w.classList.add("active") : w.classList.remove("active");
                })), function() {
                    var e = document.querySelector("#engrav"), t = document.querySelector(".float-product-info"), n = document.querySelector(".float-product-info .engrav-info");
                    e && (e.onclick = function() {
                        this.checked ? (n.classList.add("active"), t.classList.add("engrav-view")) : (n.classList.remove("active"), 
                        t.classList.remove("engrav-view"), document.querySelector("#engrav-line-0").value = "", 
                        document.querySelector("#engrav-line-1").value = "");
                    });
                }(), function() {
                    for (var e = document.querySelectorAll(".float-product-info .engrav-info__inner .input-block .input-line"), t = 0; t < e.length; t++) e[t].onkeyup = function(e) {
                        return function() {
                            var t = this.value.length;
                            document.getElementById("count-line-" + e).innerHTML = t;
                        };
                    }(t);
                }(), document.querySelectorAll(".select").forEach(function(e) {
                    !e.classList.contains("select-account") && function(e) {
                        var t = e.querySelector(".select-list"), n = e.querySelector("svg"), o = e.querySelector(".select-title"), r = o.querySelector("span"), c = t.querySelectorAll(".select-item");
                        function i() {
                            t.classList.remove("active"), n.classList.remove("active");
                        }
                        o.addEventListener("click", function() {
                            t.classList.contains("active") ? i() : (t.classList.add("active"), n.classList.add("active"));
                        }), c.forEach(function(e) {
                            e.addEventListener("click", function(e) {
                                (function(e) {
                                    r.innerHTML = e.closest(".select-item").querySelector("span").innerHTML;
                                })(e.target), i(), function(e) {
                                    if (document.getElementById("team-select")) {
                                        var t = e.closest(".select-item").getAttribute("data-select"), n = document.querySelector('.team-block__item[data-tab="' + t + '"]'), o = document.querySelector(".team-block__item.active");
                                        n.classList.add("active"), o.classList.remove("active");
                                    }
                                }(e.target), function(e) {
                                    if (document.getElementById("select-certif")) {
                                        var t = e.closest(".select-item").getAttribute("data-select"), n = document.querySelector('.view-certif__item[data-tab="' + t + '"]'), o = document.querySelector(".view-certif__item.active");
                                        n.classList.add("active"), o.classList.remove("active");
                                    }
                                }(e.target);
                            });
                        }), document.addEventListener("click", function(e) {
                            if (e.target.classList.contains("select-title") || e.target.classList.contains("select-inner-title")) return !1;
                            i();
                        });
                    }(e);
                }), (0, a.ZP)(".tooltip-icon", {
                    content: function(e) {
                        var t = e.getAttribute("data-template");
                        return document.getElementById(t).innerHTML;
                    },
                    allowHTML: !0,
                    interactive: !0,
                    trigger: "click",
                    onShow: function(e) {
                        e.reference.closest(".item").style.zIndex = 2;
                    },
                    onHide: function(e) {
                        e.reference.closest(".item").style.zIndex = 1;
                    }
                }), function() {
                    var e = window.innerHeight;
                    document.querySelectorAll(".get-book").forEach(function(t) {
                        t.addEventListener("click", function(t) {
                            t.preventDefault();
                            var n, o = this.getAttribute("data-id"), r = document.getElementById(o);
                            n = e > 600 ? e - 160 : e - 280, r.classList.add("active"), document.querySelector("header").style.zIndex = 0;
                            var c = r.querySelector(".popup-classes__block"), i = c.offsetHeight, l = c.querySelector(".inner");
                            l.querySelector(".scroll-inner"), u().disablePageScroll(l), n <= i && (l.style.height = n + "px", 
                            new d.Z(l));
                        });
                    }), document.querySelectorAll(".popup-classes .close").forEach(function(e) {
                        e.addEventListener("click", function() {
                            document.querySelectorAll(".popup-classes").forEach(function(e) {
                                e.classList.remove("active");
                            }), u().enablePageScroll(), document.querySelector("header").style.zIndex = 4;
                        });
                    });
                }(), document.querySelectorAll(".trigger").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        e.preventDefault();
                        var t = e.target.closest(".item"), n = document.querySelector(".item.active");
                        t.classList.contains("active") ? t.classList.remove("active") : t.classList.add("active"), 
                        n && n.classList.remove("active");
                    });
                }), function() {
                    var e = document.querySelector(".popup-adress"), t = document.querySelector("[add-new-adress]");
                    if (e) {
                        var n = e.querySelector(".scroll-block");
                        t.addEventListener("click", function(t) {
                            t.preventDefault(), u().disablePageScroll(), new d.Z(n), e.classList.add("open");
                        });
                    }
                }(), (k = document.querySelector(".popup-adress")) && (k.querySelector(".close").addEventListener("click", function(e) {
                    e.preventDefault(), u().enablePageScroll(), k.classList.remove("open");
                }), k.querySelector(".cancel").addEventListener("click", function(e) {
                    e.preventDefault(), u().enablePageScroll(), k.classList.remove("open");
                })), document.querySelectorAll(".legal__list .question").forEach(function(e) {
                    e.addEventListener("click", function(e) {
                        e.preventDefault();
                        var t = this.parentElement, n = document.querySelector(".legal__list-item.open");
                        t.classList.toggle("open"), n && n.classList.remove("open");
                    });
                }), window.pageYOffset > 0 && P(), window.onscroll = function() {
                    document.querySelector(".product-img__block"), P(), function() {
                        var e = document.querySelector(".float-product-info"), t = document.querySelector(".top-product .inner .price-info .count-add .count-block");
                        if (e) {
                            var n = t.offsetTop;
                            window.pageYOffset > n ? e.classList.add("active") : e.classList.remove("active");
                        }
                    }();
                }, window.onresize = function(e) {
                    A();
                }, function(e) {
                    f.p8.registerPlugin(y.L);
                    var t = e && e.selector ? e.selector : 'a[href^="#"]', n = document.querySelectorAll(t), o = e && e.idAttr ? e.idAttr : "href", r = e && e.offset ? e.offset : 0;
                    n.length && n.forEach(function(e, t) {
                        var n = e.getAttribute(o);
                        e.addEventListener("click", function(e) {
                            e.preventDefault(), n.length > 1 && f.p8.to(window, {
                                duration: 1,
                                ease: "Power2.easeOut",
                                scrollTo: {
                                    y: n,
                                    offsetY: r
                                }
                            });
                        });
                    });
                }({
                    selector: ".scroll-to",
                    offset: 64
                });
                var I = document.querySelectorAll("[quant-input]"), B = document.querySelectorAll("[add-cart]");
                B.length > 0 && B.forEach(function(e) {
                    e.addEventListener("submit", function(t) {
                        var n, o = document.querySelector("#engrav-line-0"), r = document.querySelector("#engrav-line-1"), c = document.querySelector("#tailored");
                        n = (o || r) && (o.value.length > 0 || r.value.length > 0) ? {
                            items: [ {
                                quantity: e.elements.quantity.value,
                                id: e.elements.id.value,
                                properties: {
                                    line1: o.value,
                                    line2: r.value
                                }
                            } ]
                        } : c ? {
                            items: [ {
                                quantity: e.elements.quantity.value,
                                id: e.elements.id.value,
                                properties: {
                                    blend: c.value
                                }
                            } ]
                        } : {
                            items: [ {
                                quantity: e.elements.quantity.value,
                                id: e.elements.id.value
                            } ]
                        }, t.preventDefault(), v().post("/cart/add.js", n).then(function(e) {
                            -1 != window.location.href.indexOf("?cart=true") ? location.reload() : window.location.href = "/cart";
                        });
                    });
                }), I.length > 0 && I.forEach(function(e, t) {
                    var n = document.querySelectorAll("[inc-quant]")[t], o = document.querySelectorAll("[dec-quant]")[t];
                    function r(e, t) {
                        1 == parseInt(e.dataset.top) && v().post("/cart/change.js", {
                            quantity: t,
                            line: e.dataset.line
                        }).then(function(t) {
                            var n = document.querySelector("[cart-price]"), o = n.dataset.currency + t.data.total_price / 100;
                            n.innerHTML = o.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            var r = n.dataset.currency + t.data.items[e.dataset.line - 1].final_line_price / 100;
                            e.closest(".item").querySelector(".price").innerHTML = r;
                        });
                    }
                    n.addEventListener("click", function() {
                        var t = e.value;
                        t < parseInt(e.dataset.max) && t++, e.value = t, r(e, t);
                    }), o.addEventListener("click", function() {
                        var t = e.value;
                        t > 1 && t--, e.value = t, r(e, t);
                    });
                });
                var O = window.location.href.split("?");
                null != O[1] && "true" == new URLSearchParams(O[1]).get("cart") && (document.querySelector(".cart-block").classList.add("open"), 
                u().disablePageScroll()), document.querySelectorAll("[remove-line]").forEach(function(e) {
                    e.addEventListener("click", function(t) {
                        t.preventDefault();
                        var n = parseInt(e.dataset.line);
                        v().post("/cart/change.js", {
                            quantity: 0,
                            line: n
                        }).then(function() {
                            -1 != window.location.href.indexOf("?cart=true") ? location.reload() : window.location.href = "/cart";
                        });
                    });
                });
                var H = document.querySelectorAll(".fadeY");
                document.querySelectorAll(".fadeIn").forEach(function(e) {
                    f.p8.timeline({
                        scrollTrigger: {
                            trigger: e,
                            start: "top bottom-=100px"
                        }
                    }).to(e, {
                        opacity: 1,
                        ease: "Power1.easeIn",
                        duration: 1,
                        delay: 0
                    });
                }), H.forEach(function(e) {
                    f.p8.timeline({
                        scrollTrigger: {
                            trigger: e,
                            start: "top bottom-=100px"
                        }
                    }).to(e, {
                        y: 0,
                        ease: "Power1.easeOut",
                        duration: 1,
                        delay: .2,
                        onStart: function() {
                            f.p8.to(e, {
                                opacity: 1,
                                ease: "Power1.easeIn",
                                duration: 1,
                                delay: 0
                            });
                        }
                    });
                }), document.querySelectorAll(".line").forEach(function(e) {
                    f.p8.timeline({
                        scrollTrigger: {
                            trigger: e,
                            start: "top bottom-=100px"
                        }
                    }).to(e, {
                        scaleY: 1,
                        delay: .2
                    });
                });
                var D = document.querySelectorAll("[open-example]"), M = document.querySelector(".example-popup");
                D.length > 0 && M && D.forEach(function(e) {
                    e.addEventListener("click", function() {
                        M.classList.add("active");
                    });
                });
                var j = document.querySelector("[to-words]");
                j && (j.innerHTML = function(e) {
                    var t = [ "", "thousand", "million", "billion", "trillion" ], n = [ "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine" ], o = [ "ten", "eleven", "twelve", "thirteen", "fourteen", "fifteen", "sixteen", "seventeen", "eighteen", "nineteen" ], r = [ "twenty", "thirty", "forty", "fifty", "sixty", "seventy", "eighty", "ninety" ];
                    if ((e = (e = e.toString()).replace(/[\, ]/g, "")) != parseFloat(e)) return "not a number ";
                    var c = e.indexOf(".");
                    if (-1 == c && (c = e.length), c > 15) return "too big";
                    for (var i = e.split(""), l = "", a = 0, s = 0; s < c; s++) (c - s) % 3 == 2 ? "1" == i[s] ? (l += o[Number(i[s + 1])] + " ", 
                    s++, a = 1) : 0 != i[s] && (l += r[i[s] - 2] + " ", a = 1) : 0 != i[s] && (l += n[i[s]] + " ", 
                    (c - s) % 3 == 0 && (l += "hundred "), a = 1), (c - s) % 3 == 1 && (a && (l += t[(c - s - 1) / 3] + " "), 
                    a = 0);
                    if (c != e.length) {
                        var u = e.length;
                        for (l += "point ", s = c + 1; s < u; s++) l += n[i[s]] + " ";
                    }
                    return l.replace(/\s+/g, " ");
                }(j.innerHTML));
                var C = document.querySelectorAll("[message-sent]");
                C.length > 0 && (2 == C.length && document.querySelector(".footer-send") && document.querySelector(".footer-send").classList.remove("active"), 
                C.forEach(function(e) {
                    e.classList.contains("get-touch") || (document.querySelector("header").style.zIndex = 0, 
                    document.body.style.overflow = "hidden", e.querySelectorAll(".close").forEach(function(t) {
                        t.addEventListener("click", function() {
                            e.classList.remove("active"), document.body.style.overflow = "inherit", document.querySelector("header").style.zIndex = 4;
                        });
                    }));
                }));
            };
            window.addEventListener("load", function() {
                !function() {
                    var e = document.body.getAttribute("data-template");
                    if (e) {
                        var t = {
                            blog: r
                        };
                        e && t[e] && t[e]();
                    }
                }(), g();
            });
        },
        586: function(e, t, n) {
            e.exports = n.p + "layout.theme.styleLiquid.css.liquid";
        }
    }, n = {};
    function o(e) {
        var r = n[e];
        if (void 0 !== r) return r.exports;
        var c = n[e] = {
            exports: {}
        };
        return t[e].call(c.exports, c, c.exports, o), c.exports;
    }
    o.m = t, e = [], o.O = function(t, n, r, c) {
        if (!n) {
            var i = 1 / 0;
            for (s = 0; s < e.length; s++) {
                n = e[s][0], r = e[s][1], c = e[s][2];
                for (var l = !0, a = 0; a < n.length; a++) (!1 & c || i >= c) && Object.keys(o.O).every(function(e) {
                    return o.O[e](n[a]);
                }) ? n.splice(a--, 1) : (l = !1, c < i && (i = c));
                l && (e.splice(s--, 1), t = r());
            }
            return t;
        }
        c = c || 0;
        for (var s = e.length; s > 0 && e[s - 1][2] > c; s--) e[s] = e[s - 1];
        e[s] = [ n, r, c ];
    }, o.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return o.d(t, {
            a: t
        }), t;
    }, o.d = function(e, t) {
        for (var n in t) o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
        });
    }, o.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), o.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, function() {
        var e;
        o.g.importScripts && (e = o.g.location + "");
        var t = o.g.document;
        if (!e && t && (t.currentScript && (e = t.currentScript.src), !e)) {
            var n = t.getElementsByTagName("script");
            n.length && (e = n[n.length - 1].src);
        }
        if (!e) throw new Error("Automatic publicPath is not supported in this browser");
        e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), o.p = e;
    }(), function() {
        var e = {
            233: 0
        };
        o.O.j = function(t) {
            return 0 === e[t];
        };
        var t = function(t, n) {
            var r, c, i = n[0], l = n[1], a = n[2], s = 0;
            for (r in l) o.o(l, r) && (o.m[r] = l[r]);
            if (a) var u = a(o);
            for (t && t(n); s < i.length; s++) c = i[s], o.o(e, c) && e[c] && e[c][0](), e[i[s]] = 0;
            return o.O(u);
        }, n = self.webpackChunkcambridge_distillery = self.webpackChunkcambridge_distillery || [];
        n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n));
    }();
    var r = o.O(void 0, [ 644 ], function() {
        return o(537);
    });
    r = o.O(r);
}();


/*Fixed Cart Sidebar*/

function sticky_relocate() {
  if($(window).width() > 1200){
    var window_top = $(window).scrollTop();
    var footer_top = $("#shopify-section-footer").offset().top - 90;

    var div_top = $('#sticky-anchor').offset().top;
    var div_height = $("#sticky").height();
    
    if (window_top + div_height > footer_top)
        $('#sticky').removeClass('stick');    
    else if (window_top > div_top) {
        $('#sticky').addClass('stick');
      	$('#shopify-section-footer').addClass('footer__space');
    } else {
        $('#sticky').removeClass('stick');
    }
  }
}


jQuery(document).ready(function($){
    $(window).scroll(sticky_relocate);
    //sticky_relocate();
  $('.popup_upsell_inner').on('click', '.close_me', function(e){
    $('.popup_upsell').removeClass('popup_upsell_active');
  });

  // Popup Reviews Active
  $('.popup_reviews').addClass('active_popup_reviews');
  $('.popup_reviews').on('click','.popup_reviews_close', function(e) {
    $('.popup_reviews').removeClass('active_popup_reviews');
  });
});